/*
 * @Author: 邱扬
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-09-14 18:01:37
 * @LastEditTime: 2022-01-04 15:59:31
 */
import { post, } from 'utils/request';
import $api from "src/config/api.config"  
//获取my-orders数据
export const getOrdersInfo = async(patams = null) => {
  try {
    const res = await post($api.HOME_LATEST_ORDER, patams);
    return res.data
  } catch (error) {
    console.error('getOrdersInfo',error)
    return Promise.resolve(null)
  }
};

/**
 * @Date: 2021-09-16 15:03:54
 * @LastEditTime: 
 * @description: 获取最新订单
 * @param {*} params
 * @return {*}
 */
export const getLasterOrder = async(order=false,params = null) => {
  if(!params){
    params = {
      appId: null,
      etime: null,
      orderId: null,
      page: 0,
      pageSize: 10,
      platform: null,
      region: null,
      state: null,
      stime: null,
      activeHeader: true
    }
  }
  const res = await post($api.ACTIVE_LATEST_ORDER, params);
  if (res.code === 0&&order===false) {
    // latestOrders.value = formatTableData(res.data.list);
    return res.data.list
  }
  else if(res.code === 0&&order===true){
    return res.data
  }
  else{
    return []
  }
};

/**
 * @Date: 2021-09-16 15:03:54
 * @LastEditTime: 
 * @description: 获取关键词覆盖订单列表
 * @param {*} params
 * @return {*}
 */
export const getKeywordsrOrder = async(order = false, params = null) => {
  if(!params){
    params = {
      appId: null,
      etime: null,
      orderId: null,
      page: 0,
      pageSize: 10,
      platform: null,
      region: null,
      state: null,
      stime: null
    }
  }
  const res = await post($api.GET_KEYWORDS_ORDER, params);
  if (res.code === 0) {
    return res.data
  }
};


export const getAsoOrder = async(order=false,params = null) => {
  const res = await post($api.GET_ASO_ORDER, params);
  if (res.code === 0) {
    return res.data
  }
};

export const getGKROrder = async(order=false,params = null) => {
  const res = await post($api.GET_GUARANTEED_RANKING, params);
  if (res.code === 0) {
    return res.data
  }
};
export const getAPIOrderList = async(params) => {
  const res = await post($api.GET_API_ORDERS, params);
  if (res.code === 0) {
    return res.data
  }
};
export const getCustomOrder = async(params) => {
  const res = await post('/MyCustom/getCustomOrders', params);
  if (res && res.code === 0) {
    return res.data
  }
};
export const getCoverPackageDialog = async() => {
  const res = await post($api.GET_COVER_PACKAGE_DIALOG);
  if (res && res.code === 0) {
    return res.data
  }
};
export const setArchived = async(url, params) => {
  const res = await post(url, params);
  if (res.code === 0) {
    return res.data
  }
};
